//#region [IMPORT]

// === THIRD-PARTY ===
import React, { useMemo } from 'react';

// ### MUI / STYLES ###
import { useTheme } from '@mui/material/styles';
import {
  Autocomplete,
  TextField,
} from '@mui/material';

// === COMPONENTS ===
import Styled from 'components/Styled/Styled';

// === HOOKS ===
import { useLayout } from '../Panel/PanelContext';

//#endregion

//-----------------------------------------------------------------
export function LayoutSelect( props ) {
  //-----------------------------------------------------------------
  //#region [VALUES]

  const theme = useTheme();

  const { layouts, setLayout, layout_name } = useLayout();
  
  const _layout_items = useMemo( () => {
    let result = [];
    for( const [name, layout] of layouts.entries() ) {
      result.push( { label: name, name: name } )
    }
    return result;
  }, [layouts] );

  //#endregion

  //#region [STYLES]

  const _styles = {
    layout_select: {
      marginLeft: 'auto',
      width: '200px',
    },
  };

  const LAYOUT_SELECT = {
    id          : 'layout-select',
    name        : 'layout_select',
    sx          : _styles.layout_select,
    value       : layout_name,
    options     : _layout_items,
    getOptionLabel : (option) => {
      return typeof option === 'string' ? option : option.label
    },
    isOptionEqualToValue : (option, value) => {
      if (typeof value === 'string') {
        return option.label === value;
      }
      return option.label === value.label;
    },
    renderInput : (params) => { return <TextField {...params} variant='standard' label="Layouts" /> },
    onChange : (event, layout) => {
      setLayout( layout?.name );
    }, 
  };

  //#endregion
    
  //#region [EFFECT]

  //#endregion
  
  //#region [EVENTS]

  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Styled styles={[{width:'fit-content', height:'fit-content'},{paddingRight:'1rem'}]} disabled >
        <Autocomplete { ...LAYOUT_SELECT } />
      </Styled>
    )
  }

  //#endregion

  return display();
}